import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next';
import {glacierArchiveEnabled} from './glacierArchiveEnabled';

export const canManageGlacierArchive = (): boolean => {
	if (!glacierArchiveEnabled()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.DIRECTOR)) return false;
	return currentUserHasAccess(PermissionName.ARCHIVE);
};
